"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseShiftCancellationCreateDto = instanceOfNurseShiftCancellationCreateDto;
exports.NurseShiftCancellationCreateDtoFromJSON = NurseShiftCancellationCreateDtoFromJSON;
exports.NurseShiftCancellationCreateDtoFromJSONTyped = NurseShiftCancellationCreateDtoFromJSONTyped;
exports.NurseShiftCancellationCreateDtoToJSON = NurseShiftCancellationCreateDtoToJSON;
exports.NurseShiftCancellationCreateDtoToJSONTyped = NurseShiftCancellationCreateDtoToJSONTyped;
const NurseShiftCancellationReason_1 = require("./NurseShiftCancellationReason");
/**
 * Check if a given object implements the NurseShiftCancellationCreateDto interface.
 */
function instanceOfNurseShiftCancellationCreateDto(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
function NurseShiftCancellationCreateDtoFromJSON(json) {
    return NurseShiftCancellationCreateDtoFromJSONTyped(json, false);
}
function NurseShiftCancellationCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': (0, NurseShiftCancellationReason_1.NurseShiftCancellationReasonFromJSON)(json['reason']),
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}
function NurseShiftCancellationCreateDtoToJSON(json) {
    return NurseShiftCancellationCreateDtoToJSONTyped(json, false);
}
function NurseShiftCancellationCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'reason': (0, NurseShiftCancellationReason_1.NurseShiftCancellationReasonToJSON)(value['reason']),
        'comment': value['comment'],
    };
}
//# sourceMappingURL=NurseShiftCancellationCreateDto.js.map